import { __spreadArray, __assign } from 'tslib';
import { useCombobox } from 'downshift';
import React, { useState } from 'react';
import { AddIcon } from '@panwds/icons';
import { Portal, List, Input, Button, ListItem } from '@panwds/react-ui';
import { useSelectAll } from './useSelectAll.esm.js';

var Dropdown = function (_a) {
    var addItem = _a.addItem, anchorRef = _a.anchorRef, containerRef = _a.containerRef, items = _a.items, selectedItems = _a.selectedItems, label = _a.label, onOpenChange = _a.onOpenChange, setSelectedItems = _a.setSelectedItems;
    var _b = useState(""), inputValue = _b[0], setInputValue = _b[1];
    var _c = useSelectAll({
        items: items,
        selectedItems: selectedItems
    }), showSelectAll = _c.showSelectAll, allSelected = _c.allSelected, selectAllItem = _c.selectAllItem;
    var displayItems = showSelectAll
        ? __spreadArray(["".concat(selectAllItem.value)], items, true) : items;
    var addValue = function () {
        var trimmmedValue = inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim();
        if (!trimmmedValue)
            return;
        if (selectedItems.includes(trimmmedValue))
            return;
        if (!items.includes(trimmmedValue))
            addItem(trimmmedValue);
        setSelectedItems(__spreadArray([trimmmedValue], selectedItems, true));
        setInputValue("");
    };
    var _d = useCombobox({
        isOpen: true,
        items: displayItems,
        inputValue: inputValue,
        onStateChange: function (action) {
            var _a;
            var type = action.type;
            switch (type) {
                case useCombobox.stateChangeTypes.InputKeyDownEscape:
                case useCombobox.stateChangeTypes.InputBlur:
                    (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    onOpenChange(false);
                    break;
            }
        },
        stateReducer: function (state, actionAndChanges) {
            var changes = actionAndChanges.changes, type = actionAndChanges.type;
            switch (type) {
                case useCombobox.stateChangeTypes.InputKeyDownEnter:
                case useCombobox.stateChangeTypes.ItemClick:
                    return __assign(__assign({}, changes), { highlightedIndex: state.highlightedIndex });
                default:
                    return changes;
            }
        },
        selectedItem: null,
        onSelectedItemChange: function (changes) {
            var selectedItem = changes.selectedItem;
            /* istanbul ignore if */
            if (!selectedItem) {
                return;
            }
            var index = selectedItems.indexOf(selectedItem);
            var itemAlreadySelected = index >= 0;
            if (selectedItem === selectAllItem.value) {
                setSelectedItems(allSelected ? [] : items);
            }
            else if (itemAlreadySelected) {
                setSelectedItems(__spreadArray(__spreadArray([], selectedItems.slice(0, index), true), selectedItems.slice(index + 1), true).filter(Boolean));
            }
            else {
                setSelectedItems(__spreadArray(__spreadArray([], selectedItems, true), [selectedItem], false));
            }
        }
    }), getComboboxProps = _d.getComboboxProps, getInputProps = _d.getInputProps, getItemProps = _d.getItemProps, getMenuProps = _d.getMenuProps, highlightedIndex = _d.highlightedIndex;
    return (React.createElement(Portal, null,
        React.createElement("div", __assign({}, getComboboxProps({ ref: containerRef }), { className: "tw-z-30" }),
            React.createElement(List, __assign({ isOpen: true, style: {
                    margin: "0.1rem 0",
                    display: "flex"
                } }, getMenuProps({
                onKeyDown: function (event) {
                    if (event.key === "Enter") {
                        addValue();
                    }
                    if (event.key === "Escape") {
                        // Prevent the escape action from cascading, so that it only
                        // closes this select and not a Popover or Modal that it may
                        // be inside of.
                        event.preventDefault();
                    }
                }
            })),
                React.createElement("div", { className: "tw-flex tw-flex-col tw-w-full" },
                    React.createElement("div", { className: "tw-bg-white dark:tw-bg-gray-1000 tw-z-10 tw-shadow" },
                        React.createElement("div", { className: "tw-flex tw-space-x-2 tw-p-2" },
                            React.createElement(Input, __assign({ placeholder: "Add ".concat(label) }, getInputProps({
                                onChange: function (event) {
                                    var _a;
                                    setInputValue((_a = event.target.value) !== null && _a !== void 0 ? _a : "");
                                }
                            }))),
                            React.createElement(Button, { icon: React.createElement(AddIcon, { className: "tw-absolute" }), "aria-label": "Add ".concat(label), onClick: addValue })),
                        showSelectAll && (React.createElement(ListItem, __assign({ active: highlightedIndex === 0, hasCheckbox: true }, selectAllItem, getItemProps({
                            item: selectAllItem.value,
                            index: 0
                        })), selectAllItem.value))),
                    React.createElement("div", { className: "tw-overflow-y-scroll" }, displayItems.map(function (item, index) {
                        if (index === 0 && item === selectAllItem.value)
                            return null;
                        return (React.createElement(ListItem, __assign({ active: highlightedIndex === index, checked: selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.includes(item), hasCheckbox: true, key: item }, getItemProps({
                            item: item,
                            index: index
                        })), item));
                    })))))));
};

export { Dropdown };
//# sourceMappingURL=Dropdown.esm.js.map
